import { Breakpoint, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export function useMediaQueryUp(key: Breakpoint | number) {
  const theme = useTheme();

  return useMediaQuery(theme.breakpoints.up(key));
}
